import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import { ChatWrapper, ContainerChat, ContainerViewChat, RoomPreviewWrapper, SelectedConversationTitle } from "./styles";
import { IcoArrowLeft, TitleH1, TitleH2 } from "components/generic";

import { DialogWrapper } from "components/containers";
import { MenuLeftSide } from "components/MenuLeftSide";
import { MainWrapper } from "pages/StudentMatches/styles";
import HowItWork from "components/HowItWork";
import Modal from "components/Modal";
import { MessageInput } from "./MessageInput";
import { MessagesList } from "./MessagesList";
import { API_USERS, } from "utils/constants";
import { StudentAboutInfo } from "pages/ProfileUser/StudentAboutInfo";
import { UserAPI } from "API/userApi";
import { Chater } from "./Chater";

import { useContextHospi } from "context/ContextHospi";
import { IDataConv, ISocketMessage, MessageActions, TArgFuncSendMsg, } from "interfaces/interfacesChat";
import { NoChatsInfoSection } from "./SimpleComponents";
import { IUserShot } from "interfaces/intarfaces";
import { theme } from "styles/theme";
import useSizeWindow from "utils/hooks/useWindowSize";
import { HelpWidget } from "components/HelpWidget";
import { useNavigate } from "react-router-dom";
import { LoaderCustom } from "../../components/Loader";
import { DetailedRoomInfo } from "../DetailedRoomInfo";
import { useContextHost } from "../../context/ContextHost";
import { useLocation } from "react-router";

const emptyConv = {
  name: "",
  chat_id: "",
  user_id: "",
  house_id: "",
  name_house: "",
};

export const ChatPage = () => {
  const { t } = useTranslation("chats");
  const { userProfile, messageData, socketRef, setUnreadConversations, unreadConversations, setNoChatId, noChatId } = useContextHospi();
  const { getHousesShortData } = useContextHost();
  const device = useSizeWindow();
  const navigate = useNavigate()
  const location = useLocation()

  const [lastMessageDate, setLastMessageDate] = useState<{ [id: string]: string }>({})
  const [activeConv, setActiveConv] = useState<IDataConv>(emptyConv);
  const [isEmpty, setIsEmpty] = useState(false);
  const [showModal, setShowModal] = useState<number>(0);
  const [userInfo, setUserInfo] = useState<Partial<IUserShot>>({});
  const [isInChat, setIsInChat] = useState<boolean>(false)
  const [latestRead, setLatestRead] = useState<string[]>([])
  const [isConvRead, setIsConvRead] = useState<string[]>([])
  const [hideChat, setHideChat] = useState<boolean>(false)
  const [loading, setLoading] = useState<boolean>(true)
  const [currentNoChatId, setCurrentNoChatId] = useState<string>('')

  const [showRoomPreview, setShowRoomPreview] = useState<boolean>(false)

  const closeChat = (flag: boolean) => {
    setHideChat(flag)
  }

  const fetchUser = (userID: string) => {
    if (userID)
      UserAPI.get(API_USERS + userID + "/user-preview").then((response) => {
        setUserInfo(response as Partial<IUserShot>);
        setShowModal(2);
      });
  };

  useEffect(() => {
    (messageData && (messageData.action as any) !== 'message_read') && setLastMessageDate(prev => ({ ...prev, [messageData.body.chat_id as string]: messageData.body.updated_at }))
  }, [messageData])

  useEffect(() => {
    setNoChatId(false)
    setCurrentNoChatId('')
  }, [location.pathname])

  const sendMessage: TArgFuncSendMsg = (newMsg, mode, create_at) => {
    console.log(activeConv)
    if (activeConv.chat_id.length && socketRef?.current?.readyState === 1) {
      let candidateMessage: ISocketMessage = {
        action: mode ?? MessageActions.MESSAGE_NEW,
        body: { text: newMsg },
        author_id: userProfile?.user_id!,
        chat_id: activeConv.chat_id,
        is_read: newMsg === 'read',
        created_at: create_at
      };
      candidateMessage.created_at = create_at;
      if (
        newMsg !== 'invitation declined' &&
        newMsg !== 'invitation accepted' &&
        create_at &&
        [MessageActions.MESSAGE_DELETE, MessageActions.MESSAGE_UPDATE].includes(
          mode ?? MessageActions.MESSAGE_NEW
        )
      ) {
        socketRef?.current?.send(JSON.stringify(candidateMessage));
      } else if (newMsg !== 'invitation declined' &&
        newMsg !== 'invitation accepted') {
        socketRef?.current?.send(JSON.stringify(candidateMessage));
      }
    }
  };

  useEffect(() => {
    getHousesShortData()
  }, [])

  const isPhone = device === "mobile";
  const [isIOS, setIsIOS] = useState<boolean>(true)
  const [isSafari, setIsSafari] = useState<any>(false)

  useEffect(() => {
    //@ts-ignore
    const isSafari = !!navigator.userAgent.match(/(iPod|iPhone|iPad)/) && navigator.userAgent.match(/AppleWebKit/)

    const updateOrientation = function () {
      setIsIOS(/iPad|iPhone|iPod/.test(navigator.userAgent) && window.orientation === 0)
    }
    setIsIOS(/iPad|iPhone|iPod/.test(navigator.userAgent) && window.orientation === 0)
    setIsSafari(isSafari)
    window.addEventListener("orientationchange", updateOrientation, false);
  }, [])

  return (
    // style={{ paddingTop: isPhone ? 120 : undefined }}
    // <ContainerView >
    <ContainerViewChat isActive={isPhone && !!activeConv.chat_id.length} >
      {!isPhone && <MenuLeftSide />}
      {
        showRoomPreview && <RoomPreviewWrapper id='wrapper' onClick={(e) => {
          //@ts-ignore
          if (e.target.id === 'wrapper') {
            setShowRoomPreview(false)
          }
        }
        }>
          <DetailedRoomInfo roomId={activeConv.house_id} setShowRoomPreview={setShowRoomPreview} />
        </RoomPreviewWrapper>
      }
      <MainWrapper
        style={{ maxWidth: "800px", display: 'block' }}
      >
        <TitleH1 style={{ marginBottom: 24 }}>{t("title")}</TitleH1>
        {(!isPhone || (isPhone && !!!activeConv.chat_id.length)) && (
          <>
            <HowItWork
              title={t("butHowItWork")}
              items={t("host.howItWork", {
                returnObjects: true,
              })}
            />
          </>
        )}
        {
          loading ? (
            <LoaderCustom
              size={5}
              color={theme.colors.bgBody}
              text={t("textLoading")}
            />
          ) : (isEmpty ? (
            <>
              <NoChatsInfoSection
                isHost={`${(userProfile?.user_type === "host")}`}
              />
              <HelpWidget
                title={t(`help.title`)}
                text={[t(`help.text`)]}
                btnText={t(`help.btnText`)}
              />
            </>
          ) : '')
        }

        <ChatWrapper isHiden={isEmpty} isIOS={isIOS} isSafari={isSafari} isActive={isPhone && !!activeConv.chat_id.length}>
          <SelectedConversationTitle>
            {!!activeConv.chat_id.length && (
              <>
                {isPhone && (
                  <IcoArrowLeft
                    size="1.5rem"
                    color={theme.colors.text}
                    style={{ marginRight: "0.7em" }}
                    onClick={() => {
                      setActiveConv(emptyConv)
                      navigate(-1)
                    }}
                  />
                )}
                <TitleH2
                  onClick={() => fetchUser(activeConv.user_id)}
                  style={{
                    textOverflow: "unset",
                    overflow: "hidden",
                    maxWidth: "70%",
                  }}
                >
                  {activeConv.name}
                </TitleH2>
                <TitleH2 style={{ color: '#EA6B26' }} onClick={() => setShowRoomPreview(true)}>
                  {activeConv.name_house}
                </TitleH2>
              </>
            )}
          </SelectedConversationTitle>
          <ContainerChat
            isHiden={isEmpty}
            isActive={isPhone && !!activeConv.chat_id.length}
          >
            <Chater
              messageData={messageData}
              lastMessageDate={lastMessageDate}
              setUnreadConversations={setUnreadConversations}
              setLoading={setLoading}
              closeChat={closeChat}
              unreadConversations={unreadConversations}
              setActiveConv={setActiveConv}
              activeConv={activeConv}
              isEmpty={setIsEmpty}
              showProfile={fetchUser}
              isPhone={isPhone}
              setLatestRead={setLatestRead}
              id="chater-place"
            />
            {!hideChat && (!isEmpty &&
              ((!isPhone && !!activeConv.chat_id.length) ||
                (isPhone && !!activeConv.chat_id.length)) && (
                <>
                  <MessagesList
                    activeConvId={activeConv.chat_id}
                    currentNoChatId={currentNoChatId}
                    isInChat={isInChat}
                    setIsConvRead={setIsConvRead}
                    latestRead={latestRead}
                    chater={activeConv}
                    setLatestRead={setLatestRead}
                    newMessage={messageData!}
                    handleMessage={sendMessage}
                    isPhone={isPhone}
                    id="message-place"
                  />
                  <MessageInput
                    activeConvId={activeConv.chat_id}
                    currentNoChatId={currentNoChatId}
                    setCurrentNoChatId={setCurrentNoChatId}
                    noChatId={noChatId}
                    socketRef={socketRef}
                    setIsInChat={setIsInChat}
                    setMessageData={sendMessage}
                    id="input-place"
                    isPhone={isPhone}
                  />
                </>
              ))}
          </ContainerChat>
        </ChatWrapper>
      </MainWrapper>
      {
        !!showModal && (
          <Modal isShow={!!showModal} handleClose={() => setShowModal(0)}>
            {showModal === 2 && userInfo && (
              <DialogWrapper style={{ gridTemplateRows: "repeat(2, auto)" }}>
                <StudentAboutInfo
                  {...userInfo}
                  closeBtn={() => setShowModal(0)}
                />
              </DialogWrapper>
            )}
          </Modal>
        )
      }
      {/* </ContainerView> */}
    </ContainerViewChat >
  );
};
